export enum ConstructionTypeCodeEnum {
    GasPipeline = 'GAS_PIPELINE',
    Motorway = 'MOTORWAY',
    OilPipeline = 'OIL_PIPELINE',
    PlantArea = 'PLANT_AREA',
    Powerline = 'POWERLINE',
    SitePreparation = 'SITE_PREPARATION',
    Unset = 'UNSET',
    WaterPipeline = 'WATER_PIPELINE',
    WeltCluster = 'WELT_CLUSTER',
}
